import axios from 'axios';
import type { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { loadingService } from '../services/loadingService';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — attach Bearer token from localStorage
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    loadingService.increment();
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    loadingService.decrement();
    return Promise.reject(error);
  }
);

// Response interceptor — handle 401 by redirecting to /login
api.interceptors.response.use(
  (response: AxiosResponse) => {
    loadingService.decrement();
    return response;
  },
  (error) => {
    loadingService.decrement();
    if (error.response?.status === 401) {
      loadingService.reset();
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
